import React, { createContext, useContext, ReactNode } from "react";
import { useFonts } from "expo-font";
import { AntDesign, FontAwesome, FontAwesome5 } from "@expo/vector-icons";

interface FontContextProps {
  fontsLoaded: boolean;
  fontError: Error | null;
}

const FontContext = createContext<FontContextProps>({
  fontsLoaded: false,
  fontError: null,
});

export const FontProvider = ({ children }: { children: ReactNode }) => {
  const [fontsLoaded, fontError] = useFonts({
    Roboto: require("../../assets/fonts/Roboto-Regular.ttf"),
    "Roboto-Regular": require("../../assets/fonts/Roboto-Regular.ttf"),
    "Roboto-Medium": require("../../assets/fonts/Roboto-Medium.ttf"),
    "Roboto-Bold": require("../../assets/fonts/Roboto-Bold.ttf"),
    "Roboto-Semibold": require("../../assets/fonts/Roboto-Semibold.ttf"),
    ...AntDesign.font,
    ...FontAwesome.font,
    ...FontAwesome5.font,
  });

  return (
    <FontContext.Provider
      value={{
        fontsLoaded: fontsLoaded || !!fontError,
        fontError,
      }}
    >
      {children}
    </FontContext.Provider>
  );
};

export const useFontContext = (): FontContextProps => {
  const context = useContext(FontContext);
  return context;
};

export default FontContext;
